
<div class="nav-mainMenu">
  <div class="nav-mainMenu-item" @click="screenClientsBookSelected">
    <div class="btn-profil"></div>
  </div>
  <div class="nav-mainMenu-item" @click="screenStatsSelected">
    <div class="btn-stats"></div>
  </div>
  <div class="nav-mainMenu-item" @click="showHideScreenReviews">
    <div class="btn-leaveRate"></div>
  </div>
  <el-popover placement="right" width="360" trigger="click" popper-class="nav-mainMenu-sub-container"
    v-model="parametersMenu">
    <div class="nav-mainMenu-sub" v-if="getUser !== null">
      <div class="nav-mainMenu-sub-item nav-mainMenu-sub-header">{{ getAllInfos.restoName }}</div>
      <div class="nav-mainMenu-sub-item" @click="printResas">Imprimer les réservations affichées</div>
      <div class="nav-mainMenu-sub-item" @click="screenResaListSelected">Listing des réservations par date</div>
      <div class="nav-mainMenu-sub-item" @click="reloadApp">Recharger</div>
      <div class="nav-mainMenu-sub-item" @click="screenServicesSelected">Paramétrer les services</div>
      <div class="nav-mainMenu-sub-item" @click="screenEventsSelected">Paramétrer les évènements</div>
      <div class="nav-mainMenu-sub-item" @click="screenDiscountSelected">Paramétrer les réductions</div>
      <div class="nav-mainMenu-sub-item" @click="popupCreateRoomSelected">Paramétrer les salles</div>
      <div class="nav-mainMenu-sub-item" @click="screenIntegrationSelected">Intégration</div>
      <div class="nav-mainMenu-sub-item" @click="screenInfosSelected">Informations générales</div>
      <div class="nav-mainMenu-sub-item" v-if="!getNotifIsAllowed" @click="allowNotification">Activer les
        notifications</div>
      <div class="nav-mainMenu-sub-item" @click="logout">Logout</div>
      <div class="nav-mainMenu-sub-item" v-if="isPermanance" @click="permananceScreen">Permanence</div>
    </div>
    <div slot="reference" class="nav-mainMenu-item-line btn-properties nav-toggle nav-toggle-white nav-toggle-size2">
      <div id="nav-icon3" :class='{ "open": parametersMenu }'><span></span><span></span><span></span><span></span>
      </div>
    </div>
  </el-popover>
</div>
